import React from "react";
import "./skills.css";
import { skillList } from "../../skillsList.js";
import { useContext } from "react";
import { ThemeContext } from "../../context";

const Skills = ({ title, desc,index }) => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="s">
      <div className="s-header">
        <h1> My Toolkit </h1>
        <div className="line-wrapper">
          <div className="line"></div>
          <div className="dot"></div>
          <div className="dot"></div>
          <div className="line"></div>
        </div>
      </div>

      <div className="s-list">
        {skillList.map((skill, index) => (
          <div className="s-skill">
            <span className="skill" key={index} style={{ color: darkMode && "#fff" }}>
              {skill.icon}
            </span>
            <p>{skill.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
